import { Injectable } from '@angular/core';
import { interval, map, takeUntil, timer } from 'rxjs';

export const linearEasing = (t: number) => t;

@Injectable({
  providedIn: 'root',
})
export class EasingService {
  public createEasing(
    start: number,
    end: number,
    duration: number,
    numSteps: number,
    easingFunction: (t: number) => number,
  ) {
    const steps = numSteps || 100; // the number of steps for the interval (smoothness)
    const stepDuration = duration / steps; // how often to emit a value
    const totalDuration = timer(duration); // timer to stop after the duration

    return interval(stepDuration).pipe(
      map((step) => {
        const t = step / steps; // t is a normalized time between 0 and 1
        return start + (end - start) * easingFunction(t); // interpolate between start and end with easing
      }),
      takeUntil(totalDuration), // stop after the total duration
    );
  }
}
